import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, MonitorSmartphone, Clock } from 'lucide-react';

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen">
      <section className="bg-primary text-white py-24 px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight">
            Digitale Qualitätssicherung.<br/>
            <span className="text-accent">Exakt geprüft.</span>
          </h1>
          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed">
            ENVISU steht für digitale Qualitätssicherung auf höchstem Niveau. Als akkreditierter
            Prüfdienstleister entwickeln und validieren wir Testverfahren für Banken, Fintechs und
            Versicherungen. Unser Fokus: reale Benutzertests unter echten Bedingungen. Denn nur wer
            Anwendungen so prüft, wie sie später genutzt werden, kann Schwachstellen zuverlässig aufdecken.
          </p>
          <p className="text-md text-slate-400 mb-10 max-w-3xl mx-auto">
            Mit einem bundesweiten Netzwerk geschulter Tester gewährleisten wir realistische
            Prüfszenarien – für sichere, intuitive und fehlerfreie digitale Prozesse.
          </p>
          <Link to="/karriere" className="bg-accent text-primary font-bold px-8 py-4 rounded-md hover:bg-white transition-colors text-lg">
            Jetzt Tester werden
          </Link>
        </div>
      </section>

      <section className="py-20 px-4 bg-background">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-primary mb-12">
            Warum als Tester bei ENVISU?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl border border-border shadow-sm hover:shadow-md transition-shadow">
              <CheckCircle className="w-12 h-12 text-accent mb-6" />
              <h3 className="text-xl font-bold text-primary mb-4">1. Vergütung pro Testauftrag</h3>
              <p className="text-muted-foreground">
                Jeder erfolgreich durchgeführte Test wird vergütet. Sie bestimmen, wie viele
                Aufträge Sie annehmen – mehr Tests, mehr Ertrag. Perfekt als Nebenverdienst.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl border border-border shadow-sm hover:shadow-md transition-shadow">
              <MonitorSmartphone className="w-12 h-12 text-accent mb-6" />
              <h3 className="text-xl font-bold text-primary mb-4">2. 100 % Homeoffice</h3>
              <p className="text-muted-foreground">
                Testen Sie von überall: ob am Küchentisch, im Café oder auf der Couch. Alles, was Sie
                brauchen, ist ein Smartphone mit Kamera und eine ruhige Umgebung.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl border border-border shadow-sm hover:shadow-md transition-shadow">
              <Clock className="w-12 h-12 text-accent mb-6" />
              <h3 className="text-xl font-bold text-primary mb-4">3. Flexible Zeiten & Minijob</h3>
              <p className="text-muted-foreground">
                Sie entscheiden, wann Sie testen. Passen Sie die Aufträge einfach an Ihren Alltag an –
                ideal für Studierende, Eltern oder Berufstätige, die etwas dazuverdienen möchten.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}